// api should be here
import { http } from '@/utils/http';
import qs from 'qs';
// 活动api baseurl
const urlPrefix = 'vote/2025project/q1/2025dlhmxc/controller.php?enews=';

const getBaseInfo = () => {
  return http.get(`${urlPrefix}base-info`);
};

// 获取列表
const getList = (page: number, keyword?: string) => {
  return http.get(`${urlPrefix}vote-list`, {
    params: {
      page: page,
      search: keyword,
    },
  });
};
// 规则
export const getRule = () => {
  return http.get(`${urlPrefix}rules`);
};

// 提交
export const save = (data: any) => {
  const qsData = qs.stringify(data);
  return http.post(`${urlPrefix}save`, qsData, { headers: {} });
};

// 详情
export const detail = (id: any) => {
  return http.get(`${urlPrefix}detail`, {
    params: {
      id,
    },
  });
};
// 提交详情
export const detailUser = (id: any, unionid?: any) => {
  return http.get(`${urlPrefix}detail-user`, {
    params: {
      id,
      unionid,
    },
  });
};
// 获取列表
export const getUserList = (page: number, unionid?: any) => {
  return http.get(`${urlPrefix}vote-list-user`, {
    params: {
      page,
      unionid,
    },
    headers: {},
  });
};
const deleteActive = (data: any) => {
  console.log(data);
  const qsData = qs.stringify(data);
  return http.post(`${urlPrefix}deleteActive`, qsData);
};
const getNews = (page: any, category: any, classId: any) => {
  return http.get(
    `/v1/news/topicList?page=${page}&classId=${classId}&category=${category}`,
  );
};

// 获取列表
const backList = (page: number, keyword?: string) => {
  return http.get(`${urlPrefix}vote-list-back`, {
    params: {
      page: page,
      search: keyword,
    },
  });
};
// 详情
export const backDetail = (id: any) => {
  return http.get(`${urlPrefix}detail-back`, {
    params: {
      id,
    },
  });
};
export { getBaseInfo, getList, getNews, deleteActive, backList };
